export default __webpack_public_path__ + "static/media/indexing_img.bad42a18.jpeg";